import { SearchFilterKeys, SearchFilters } from '@cinch-nx/data-search'

const titleAndHeaderPriorityOrderedFacets: ReadonlySet<SearchFilterKeys> =
  new Set([
    'colour',
    'make',
    'model',
    'trim',
    'driveType',
    'gearbox',
    'doors',
    'fuelType',
    'bodyType',
    'seats',
    'fromYear',
    'toYear',
    'vehicleYear',
  ])

export const getOrderedUrlPathSegmentFilters = (
  pathSegmentFilters: Partial<SearchFilters>,
) => {
  const orderedPathSegments = new Map<string, string[]>()
  // Special handling for fromYear and toYear
  // If both are present with the same value, we only add one of them
  let skipToYear = false

  if (
    pathSegmentFilters.fromYear?.length === 1 &&
    pathSegmentFilters.toYear?.length === 1 &&
    pathSegmentFilters.fromYear[0] === pathSegmentFilters.toYear[0]
  ) {
    // They have the same value, we'll only add fromYear later in the loop
    skipToYear = true
  }

  for (const filterKey of titleAndHeaderPriorityOrderedFacets.values()) {
    // Skip toYear if it's the same as fromYear (we already added fromYear)
    if (filterKey === 'toYear' && skipToYear) {
      continue
    }

    const filter = pathSegmentFilters[filterKey]
    // only add the filter if it's present
    if (!filter || filter.length !== 1) {
      continue
    }
    //orderedPathSegments.set(filterKey, filter)
    orderedPathSegments.set(filterKey, filter)
  }
  return orderedPathSegments
}
